import { useClickOutside } from "@/utils";
import { Table } from "@tanstack/react-table"
import {
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsLeft,
    ChevronsRight,
} from "lucide-react"
import { useRef, useState } from "react"
import { CSSTransition } from "react-transition-group";

interface DataTablePaginationProps<TData> {
    table: Table<TData>
}

export function DataTablePagination<TData>({
    table,
}: DataTablePaginationProps<TData>) {
    const [showPageBatches, setShowPageBatches] = useState(false);
    const areaRef = useRef(null);
    useClickOutside(areaRef, () => {
        setShowPageBatches(false);
    });
    return (
        <div className="table-pagination">
            <div className="table-pagination__table-capacity">
                <div className="table-pagination__capacity-controls">
                    <div className="table-pagination__count">
                        <button className="table-pagination__set-page-size" onClick={() => {
                            setShowPageBatches(!showPageBatches);
                        }}>
                            <span>Items:</span>
                            <span>{table.getState().pagination.pageSize}</span>
                            <ChevronDown width={14} height={14} />
                        </button>
                        <CSSTransition in={showPageBatches}
                            timeout={200}
                            classNames="fade"
                            exit={false}
                            unmountOnExit>
                            <div className="table-pagination__sizes-list" ref={areaRef}>
                                {[10, 20, 30, 40, 50].map((pageSize) => (
                                    <button className="table-pagination__size-button" key={pageSize} onClick={() => {
                                        table.setPageSize(pageSize);
                                        setShowPageBatches(false);
                                    }} >
                                        <span className="table-pagination__size-button-check" >
                                            {table.getState().pagination.pageSize === pageSize && <Check width={18} height={18} />}
                                        </span>
                                        {pageSize}
                                    </button>
                                ))}
                            </div>
                        </CSSTransition>

                    </div>
                    <div className="table-pagination__total-pages">
                        Page {table.getState().pagination.pageIndex + 1} of{" "}
                        {table.getPageCount() > 0 ? table.getPageCount() : 1}
                    </div>
                </div>

            </div>

            <div>
                <div className="table-pagination__page-controls">
                    <button
                        className="table-pagination__page-control"
                        onClick={() => table.setPageIndex(0)}
                        disabled={!table.getCanPreviousPage()}
                    >
                        <ChevronsLeft />
                    </button>
                    <button
                        className="table-pagination__page-control"
                        onClick={() => table.previousPage()}
                        disabled={!table.getCanPreviousPage()}
                    >
                        <ChevronLeft />
                    </button>
                    <div className="table-pagination__current-page">
                        {table.getState().pagination.pageIndex + 1}
                    </div>
                    <button
                        className="table-pagination__page-control"
                        onClick={() => table.nextPage()}
                        disabled={!table.getCanNextPage()}
                    >
                        <ChevronRight />
                    </button>
                    <button
                        className="table-pagination__page-control"
                        onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                        disabled={!table.getCanNextPage()}
                    >
                        <ChevronsRight />
                    </button>
                </div>
            </div>
        </div>
    )
}